import { render, staticRenderFns } from "./LoginCredentials.vue?vue&type=template&id=0478663f&scoped=true&"
import script from "./LoginCredentials.vue?vue&type=script&lang=js&"
export * from "./LoginCredentials.vue?vue&type=script&lang=js&"
import style0 from "./LoginCredentials.vue?vue&type=style&index=0&id=0478663f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0478663f",
  null
  
)

component.options.__file = "LoginCredentials.vue"
export default component.exports